import configuration from './../config.json'
import CarsTypesService from './../shared/services/carsTypesService'
import CookieService from './../shared/services/cookiesService'
import { setLogout } from './authActions'

const RESPONSE_CARS_TYPES = 'RESPONSE_CARS_TYPES'
const REQUEST_CARS_TYPES_FAILURE = 'REQUEST_CARS_TYPES_FAILURE'

const responseGetCarsTypesAction = (data) => {
  return {
    type: RESPONSE_CARS_TYPES,
    data,
  }
}

const requestGetCarsTypesfailureAction = (errors) => {
  return {
    type: REQUEST_CARS_TYPES_FAILURE,
    errors,
  }
}

const getCarsTypes = () => {
  return (dispatch) => {
    CarsTypesService.getCarsTypes()
      .then((result) => {
        CookieService.updateExpires(configuration.cookieName, 12)
        
        dispatch(responseGetCarsTypesAction(result.data.types))
      })
      .catch((error) => {
        dispatch(requestGetCarsTypesfailureAction(error.response))

        if (error.response && error.response.status === 401) {
          dispatch(setLogout())
        }
      })
  }
}

export {
  getCarsTypes,
  responseGetCarsTypesAction,
  requestGetCarsTypesfailureAction,
  RESPONSE_CARS_TYPES,
  REQUEST_CARS_TYPES_FAILURE,
}
